module.exports = __webpack_public_path__ + "static/media/20190808_133645.12c5cf4b.png";